import { Component } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'order-search',
  templateUrl: './order-search.component.html',
  styleUrl: './order-search.component.scss',
  standalone: false
})
export class OrderSearchComponent {

  constructor(private readonly api: ApiService) { }

  public searchType: string = 'manual';
  public manualQuery: string = 'SELECT top 10 *\r\nFROM c\r\nWHERE c.Information.IsOrder = true';
  
  public showJson: boolean = false;
  public naturalLanguageQuery: string = '';
  public isRunning: boolean = false;
  public showFriendly: boolean = true;
  public results: any[] = [];
  public error: string = '';
  public filterText: string = '';

  public runSearch() {
    this.isRunning = true;
    this.error = '';
    if (this.searchType === 'manual') {
      this.api.OrderSearch.RunManualOrderSearch(this.manualQuery).subscribe({
        next: result => {
          this.results = result;
          this.isRunning = false;
        },
        error: err => {
          this.error = JSON.stringify(err);
          this.isRunning = false;
        }
      });
    }
    else if (this.searchType === 'ai') {
      this.api.OrderSearch.RunAISearch(this.naturalLanguageQuery).subscribe({
        next: result => {
          this.results = result;
          this.isRunning = false;
        },
        error: err => {
          this.error = JSON.stringify(err);
          this.isRunning = false;
        }
      });
    }
  }
  public copyToClipboard(object: any) {
    navigator.clipboard.writeText(JSON.stringify(object, null, 2));
  }

}
